// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3ENFF","balanceDisclaimer":"posDashboard_balanceDisclaimer__2W5E0"};